import { useCallback, useState } from 'react';

import NotificationContext from './notification-context';
import {
   ChildrenElements,
   Notification,
   NotificationConfig,
} from 'utils/interfaces/commonInterfacesAndTypes';
import useTranslation from 'next-translate/useTranslation';

const NotificationContextProvider = ({ children }: ChildrenElements) => {
   const { t } = useTranslation('common');
   const [notification, setNotification] = useState<Notification | null>(null);

   const display = useCallback(
      (notificationConfig: NotificationConfig, onNotificationFinish?: () => void) => {
          const duration = notificationConfig.duration || 4000;
         setNotification({
            text: t(notificationConfig.text),
            isSuccess: notificationConfig.isSuccess,
            className: notificationConfig.className,
         });
         setTimeout(() => {
            setNotification(null);
            onNotificationFinish?.();
         }, duration);
      },
      [t],
   );

   return (
      <NotificationContext.Provider value={{ notification, display }}>
         {children}
      </NotificationContext.Provider>
   );
};

export default NotificationContextProvider;
